import script from "./EmergencyPatientStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencyPatientStrip.vue?vue&type=script&setup=true&lang=js"

import "./EmergencyPatientStrip.vue?vue&type=style&index=0&id=f1a24e2e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1a24e2e"]])

export default __exports__